import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

const WORKLOAD_RELIABILITY_METRICS_QUERY_KEY = 'workload-reliability-metrics';

const apiFn = apiClient.costReport.getSingleWorkloadReliabilityMetrics;

export type WorkloadReliabilityMetricsQueryData = ApiResponse<typeof apiFn>;

const getWorkloadReliabilityMetricsQueryKey = (
  params?: Parameters<typeof apiFn>[0]
) => [WORKLOAD_RELIABILITY_METRICS_QUERY_KEY, ...(params ? [params] : [])];

export const useWorkloadReliabilityMetricsQuery = <
  TSelected = WorkloadReliabilityMetricsQueryData
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<WorkloadReliabilityMetricsQueryData, TSelected>
) => {
  const { data, ...rest } = useQuery(
    queryOptions({
      queryKey: getWorkloadReliabilityMetricsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      ...options,
    })
  );

  return { data, ...rest };
};
